import React, { ReactNode } from 'react';
import { 
  View, 
  StyleSheet, 
  ViewStyle, 
  TouchableOpacity, 
  TouchableOpacityProps 
} from 'react-native';
import { colors, borderRadius, spacing } from '../constants/theme';
import { useTheme } from '../context/ThemeContext';

interface CardProps extends TouchableOpacityProps {
  children: ReactNode;
  style?: ViewStyle;
  onPress?: () => void;
  shadow?: 'none' | 'light' | 'medium' | 'dark';
  borderRadius?: number;
  padding?: number;
}

const Card = ({
  children,
  style,
  onPress,
  shadow = 'light',
  borderRadius: customBorderRadius,
  padding = spacing.md,
  ...rest
}: CardProps) => {
  const { theme } = useTheme();
  
  // Get shadow style based on shadow prop
  const getShadowStyle = () => {
    switch (shadow) {
      case 'none':
        return {};
      case 'light':
        return theme.shadows.light;
      case 'medium':
        return theme.shadows.medium;
      case 'dark':
        return theme.shadows.dark;
      default:
        return theme.shadows.light;
    }
  };

  const cardStyle = [
    styles.card,
    getShadowStyle(),
    { 
      padding, 
      borderRadius: customBorderRadius || borderRadius.md,
      backgroundColor: theme.colors.card 
    },
    style,
  ];

  if (onPress) {
    return (
      <TouchableOpacity 
        style={cardStyle} 
        onPress={onPress} 
        activeOpacity={0.8}
        {...rest}
      >
        {children}
      </TouchableOpacity>
    );
  }

  return <View style={cardStyle}>{children}</View>;
};

const styles = StyleSheet.create({
  card: {
    overflow: 'hidden',
  },
});

export default Card; 